import React from 'react';
import { motion } from 'framer-motion';
import { Search, PhoneCall, Scale, FileText } from 'lucide-react';
const services = [{
  icon: <PhoneCall size={32} data-id="element-893" />,
  title: 'Early-Stage Recovery',
  description: 'Proactive communication and gentle reminders to resolve accounts before they age, preserving your customer relationships.'
}, {
  icon: <FileText size={32} data-id="element-894" />,
  title: 'Mid-Stage Collections',
  description: 'Structured, persistent follow-up strategies designed to secure payment commitments and resolve outstanding balances efficiently.'
}, {
  icon: <Scale size={32} data-id="element-895" />,
  title: 'Pre-Legal Recovery',
  description: 'Intensive collection efforts for severely delinquent accounts, preparing thorough documentation should legal action become necessary.'
}, {
  icon: <Search size={32} data-id="element-896" />,
  title: 'Skip Tracing',
  description: 'Advanced investigative techniques to locate unresponsive consumers, utilizing comprehensive databases to re-establish contact.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-897">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-898">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-899">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-900">
            Comprehensive Receivables Solutions
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-901">
            We perform collection services at every stage of delinquency,
            tailoring our approach to maximize recovery while maintaining
            professional standards.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-902">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border border-gray-100 p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow group" data-id="element-903">
              <div className="w-14 h-14 bg-brand-gray rounded-lg flex items-center justify-center text-brand-navy mb-6 group-hover:bg-brand-navy group-hover:text-white transition-colors" data-id="element-904">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-905">
                {service.title}
              </h3>
              <p className="text-brand-muted leading-relaxed" data-id="element-906">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}